{
  "$id": "http://softball.app/schemas/player",
  "title": "Player",
  "type": "object",
  "description": "Information a player",
  "required": ["id", "name", "gender", "songLink", "songStart"],
  "properties": {
    "id": {
      "type": "string",
      "tsType": "PlayerId",
      "description": "Random 64-bit unique identifier for this player"
    },
    "name": { "type": "string", "description": "Name of the player" },
    "gender": { "type": "string", "description": "Gender of the player" },
    "songLink": {
      "type": ["string","null"],
      "description": "Walkup song YouTube link"
    },
    "songStart": {
      "type": ["integer","null"],
      "description": "Walkup song start time in seconds"
    }
  }
}